import React from 'react';
import CopyToClipboard from 'react-copy-to-clipboard';
import { Alert } from '../services';
import { CopyIcon } from './icons/IconProvider';

const CopyToClipboardText = ({ text, copyMessage }) => {
  const copyWalletAddress = () => {
    Alert.success(`${copyMessage ? copyMessage : 'Copied!'}`);
  };
  return (
    <CopyToClipboard
      text={text}
      onCopy={copyWalletAddress}
      className="w-6 h-6 cursor-pointer"
    >
      <span>
        <CopyIcon />
      </span>
    </CopyToClipboard>
  );
};

export default CopyToClipboardText;
